import { createSelector } from '@ngrx/store';
import * as Utils from '@shared/core/utils';
import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteHome = createSelector(getCurrentRoute, (current) => !!current?.data?.isHomePage || Utils.Routes.isMainPage(current?.url));
